<template>
    <simple-layout>
        <basic-card>
            <template slot="header">
                Import mappings
            </template>
            <collapsible-content>
                <template slot="header">
                    Filter
                </template>
                <form-wrapper :columns="4">
                    <form-select-input v-model="mappingFilter.entity" :options="entityOptions" caption="Entity"/>
                    <form-text-input v-model="mappingFilter.kind" caption="Kind"/>
                    <form-text-input v-model="mappingFilter.value" caption="Value"/>
                </form-wrapper>
            </collapsible-content>
            <hr/>
            <data-table
                :configuration="mappingTableConfig"
                :data="filteredImportMappings"
                component-id="mappingTable"
                @focusedChanged="handleFocusedChanged"
                @add="handleAdd"
            >
                <basic-card v-if="focusedMapping !== null">
                    <template slot="header">
                        Editation mapping
                    </template>
                    <form-wrapper>
                        <form-select-input caption="Entity" v-model="focusedMapping.entity" :options="entityOptions"/>
                        <form-text-input caption="Kind" v-model="focusedMapping.kind"/>
                        <form-text-input caption="Key" v-model="focusedMapping.key"/>
                        <form-select-input caption="Value" v-model="focusedMapping.value" :options="mappedIdOptions"/>
                    </form-wrapper>
                    <simple-button @press="save">{{$t("save")}}</simple-button>
                </basic-card>
            </data-table>
        </basic-card>
    </simple-layout>
</template>

<script>
    import SimpleLayout from "../components/layout/SimpleLayout";
    import BasicCard from "../components/layout/BasicCard";
    import DataTable from "../components/table/DataTable";
    import {mapGetters} from "vuex";
    import FormWrapper from "../components/form/FormWrapper";
    import FormTextInput from "../components/form/FormTextInput";
    import FormSelectInput from "../components/form/FormSelectInput";
    import SimpleButton from "../components/button/SimpleButton";
    import CollapsibleContent from "../components/CollapsibleContent";
    export default {
        name: "ImportMappingsView",
        components: {
            CollapsibleContent,
            SimpleButton, FormSelectInput, FormTextInput, FormWrapper, DataTable, BasicCard, SimpleLayout},
        data: function () {
            return {
                focusedMapping: null,
                mappingFilter: {

                },
                mappingTableConfig: {
                    allowEdit: true,
                    enableAdd: true,
                    enableCheck: true,
                    columns: [
                        {
                            caption: "Entity",
                            datum: d => d.entity
                        },
                        {
                            caption: "Kind",
                            datum: d => d.kind
                        },
                        {
                            caption: "Key",
                            datum: d => d.key
                        },
                        {
                            caption: "Value",
                            datum: d => {
                                if(d.value == null) return "Missing mapping!";
                                if(d.entity === "account") {
                                    return this.account(d.value).name
                                }
                                else {
                                    return this.party(d.value).displayName
                                }
                            },
                            style: d => d.value == null ? ({ 'background-color': '#bb2d20'}) : undefined
                        },
                    ]
                }
            }
        },
        methods: {
            refreshData() {
                this.$store.dispatch("importMappings/refreshImportMappings");
            },
            handleFocusedChanged(focused) {
                this.focusedMapping = focused;
            },
            handleAdd() {
                this.focusedMapping = {};
            },
            save() {
                this.$store.dispatch("importMappings/saveImportMapping", this.focusedMapping)
                    .then(() => {
                        this.$notify({
                            group: 'application',
                            title: 'Import mapping saved',
                            text: `Import mapping successfully saved`,
                            type: "ok"
                        });
                        this.focusedMapping = null;
                    })
                    .then(this.refreshData)
            },
            getOptionsByEntity(entity) {
                if(entity === 'account')
                    return this.accounts.map(acc => ({name: acc.name, id: acc.id}))
                else
                    return this.parties.map(party => ({name: party.displayName, id: party.id}))
            },
        },
        computed: {
            filteredImportMappings() {
                let filtered = this.importMappings;
                const fulltextFilter = (val) => {
                    if(this.mappingFilter[val] !== undefined && this.mappingFilter[val] !== null) {
                        filtered = filtered.filter(mapping => mapping[val].includes(this.mappingFilter[val]));
                    }
                }

                if(this.mappingFilter.entity !== undefined && this.mappingFilter.entity !== null) {
                    filtered = filtered.filter(mapping => mapping.entity === this.mappingFilter.entity)
                }
                fulltextFilter("kind");
                fulltextFilter("value")


                return filtered;
            },
            mappedIdOptions() {
                if(this.focusedMapping === null) return []
                const entity = this.focusedMapping.entity;
                return this.getOptionsByEntity(entity);
            },
            entityOptions: () => [
                {id: "account", name: "Account"},
                {id: "party", name: "Party"}
                ],
            ... mapGetters({
                "importMappings": "importMappings/importMappings",
                "parties": "parties/parties",
                "party": "parties/party",
                "accounts": "banking/accounts",
                "account": "banking/account"
            })
        },
        mounted() {
            this.refreshData();
        }

    }
</script>

<style lang="scss" scoped>

</style>